import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "../components/sections/PageHero";
import PartnersMarquee from "../components/sections/PartnersMarquee";
import Testimonials from "../components/sections/Testimonials";
import Founders from "../components/sections/Founders";

const visions = [
  { tag: "01", title: "Redefine Talent Development", desc: "Move beyond traditional learning. Build an ecosystem where knowledge translates into capability and performance." },
  { tag: "02", title: "Enable Innovation & Ownership", desc: "Empower individuals to build, create and own outcomes — from careers to ventures — through guided innovation." },
  { tag: "03", title: "Accelerate Impact at Scale", desc: "Create growth pathways where talent, ideas and organisations are accelerated into measurable outcomes." },
];

const About = () => (
  <div data-testid="about-page">
    <PageHero
      kicker="/ About Deployedd Labs"
      title="The bridge that"
      accent="didn't exist."
      breadcrumb={["About Us"]}
      lead="We operate at the intersection of universities, industry and leadership — enabling seamless transitions from education to employment, management to leadership, and leadership to legacy."
    />

    <section data-testid="vision-section" className="container-wide py-24 md:py-32">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
        <div className="lg:col-span-4">
          <p className="font-mono-cust text-[11px] uppercase tracking-[0.3em] text-gray-500 mb-6">/ Vision</p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
            Three commitments<br />
            <em className="font-editorial italic text-[#9F381A]">we live by.</em>
          </h2>
        </div>
        <div className="lg:col-span-7 lg:col-start-6">
          <p className="text-lg text-ink-muted">
            Deployedd Labs is the operating system between academia, industry and emerging talent — built to deploy outcomes, not deliverables.
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 border-t border-l border-ink">
        {visions.map((v) => (
          <div key={v.tag} data-testid={`vision-${v.tag}`} className="border-r border-b border-ink p-10 md:p-14 hover:bg-[#F3F3F1] transition-colors group">
            <p className="font-mono-cust text-[11px] uppercase tracking-[0.3em] text-[#9F381A] mb-10">/ {v.tag}</p>
            <h3 className="font-heading text-2xl md:text-3xl tracking-tight mb-4 group-hover:translate-x-1 transition-transform">{v.title}</h3>
            <p className="text-base text-ink-muted leading-relaxed">{v.desc}</p>
          </div>
        ))}
      </div>
    </section>

    <section className="bg-ink text-white py-24 md:py-32">
      <div className="container-wide">
        <p className="font-mono-cust text-[11px] uppercase tracking-[0.3em] text-white/50 mb-6">/ Manifesto</p>
        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[0.95] mb-12 max-w-[22ch]">
          We collaborate across academia, industry and emerging talent — to <em className="font-editorial italic text-[#E68A6E]">build, deploy and accelerate</em> outcomes.
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 border-t border-white/15 pt-10 max-w-3xl">
          <div>
            <p className="font-heading text-3xl md:text-4xl tracking-tighter text-[#E68A6E] mb-2">Chennai · Coimbatore</p>
            <p className="text-sm uppercase tracking-[0.2em] text-white/50">Where we operate</p>
          </div>
          <div>
            <p className="font-heading text-3xl md:text-4xl tracking-tighter text-[#E68A6E] mb-2">42</p>
            <p className="text-sm uppercase tracking-[0.2em] text-white/50">Skills on the bench</p>
          </div>
        </div>
      </div>
    </section>

    <PartnersMarquee />
    <Founders />
    <Testimonials />

    <section className="container-wide py-24 md:py-32">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-8">
          <h2 className="font-heading text-4xl md:text-5xl tracking-tighter leading-[0.95]">
            Want to partner, hire from us, or<br />
            <em className="font-editorial italic text-[#9F381A]">join the bench?</em>
          </h2>
        </div>
        <div className="lg:col-span-4">
          <Link to="/contact" data-testid="about-cta" className="inline-flex items-center justify-between w-full md:w-auto gap-3 bg-ink text-white px-6 py-4 text-[11px] uppercase tracking-[0.25em] hover:bg-[#9F381A] transition-colors">
            Get in touch <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  </div>
);

export default About;
